export default __webpack_public_path__ + "587492a04c55d5304d14f11dfebaaf4a.png";